<template>
  <div class="setting">
    <h1>设置</h1>
  </div>
</template>

<script>
export default {
  name: 'setting',
  data () {
    return {
      msg: 'App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Setting.vue